import { navLinks } from "@/mocks/content";

export default function Footer() {
  const year = new Date().getFullYear();

  const handleJump = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer className="border-t border-background-200 bg-background-100 pb-8 pt-12">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">爱情岛</span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              一个专注恋爱与情感的内容小站，围绕恋爱技巧、约会攻略、两性话题、情感咨询与爱情故事，陪你把关系过得更顺畅。
            </p>
          </div>

          <div>
            <h3 className="font-label text-sm font-medium text-foreground-950">页面导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-y-3">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <button
                    type="button"
                    onClick={() => handleJump(link.id)}
                    className="font-label text-sm text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-label text-sm font-medium text-foreground-950">内容说明</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              本站内容为恋爱与情感的日常科普与经验分享，旨在提供参考与启发，不构成专业心理咨询或医疗建议。若你正经历持续的情绪困扰，建议及时寻求专业帮助。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {year} 爱情岛 · 恋爱技巧与情感文章精选</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-2-line text-primary-500"></i>
            愿每一份真心，都能被温柔以待
          </p>
        </div>
      </div>
    </footer>
  );
}